import { PropsWithChildren, ReactElement } from 'react';
import { Navigate, useParams } from 'react-router';

import { useEntitiesAccess } from '@/hooks/useEntitiesAccess';
import { ERoutes } from '@/types/routes';

export const LimitedAccessToTheEntitiesRoute = ({
  children,
}: PropsWithChildren): ReactElement | null => {
  const { entityName } = useParams();
  const { isEntityAllowed } = useEntitiesAccess();

  if (isEntityAllowed(entityName ?? '')) {
    return <>{children}</>;
  }

  return <Navigate to={ERoutes.DASHBOARD} />;
};
